/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CompositeUniqueConstraintStrategy } from "./CompositeUniqueConstraintStrategy";
import { CompositeUniqueConstraintConfig } from "./CompositeUniqueConstraintConfig";
export const CompositeUniqueConstraint = core.serialization.object({
    name: core.serialization.string(),
    fields: core.serialization.list(core.serialization.string()),
    requiredFields: core.serialization.list(core.serialization.string()).optional(),
    strategy: CompositeUniqueConstraintStrategy,
    config: CompositeUniqueConstraintConfig.optional(),
});
